import classNames from 'classnames';
import React from 'react';

export interface WindowLevelMenuItemProps {
	title: string;
	subtitle?: string;
	isSelected?: boolean;
	index?: number;
	isVisibleShortcutKey?: boolean;
}

const style = 'whitespace-nowrap text-xs text-common-light font-normal';

const WindowLevelMenuItem: React.FC<WindowLevelMenuItemProps> = ({ title, subtitle, isSelected, index, isVisibleShortcutKey }) => {
	return (
		<>
			<div
				className={classNames(
					'flex h-7 w-full flex-row items-center bg-primary-dark px-2 hover:bg-primary-light',
					isSelected && 'bg-primary-light',
				)}
			>
				<span className={`mr-2 ${style}`}>{title}</span>
				<span className={`flex-1 ${style}`}>{subtitle && `(${subtitle})`}</span>
				{!isNaN(index) && isVisibleShortcutKey ? <span className={`ml-5 ${style}`}>{`(${index + 1})`}</span> : <></>}
			</div>
		</>
	);
};

export default WindowLevelMenuItem;
